// ALIS = Advanced Life Insurance System

export const SYSTEM_NAME_ALIS = 'ALI';
export const ALIS_CANCER = 'Kreft';
export const ALIS_LIFE_ACCOUNT = 'Livkonto m/overskuddsdeling';
export const ALIS_LIFE_INSURANCE = 'Livsforsikring';
export const ALIS_LOAN_INSURANCE = 'Låneforsikring';
export const ALIS_CRITICAL_ILLNESS = 'Kritisk sykdom';
export const ALIS_OWNER_ROLES_CODE_A1 = 'A1';
export const ALIS_OWNER_ROLES_CODE_A2 = 'A2';
export const ALIS_OWNER_ROLES_CODE_G1 = 'G1'; // forsikringstaker
export const ALIS_OWNER_ROLES_CODE_G2 = 'G2';
export const ALIS_OWNER_ROLES_CODE_F1 = 'F1'; // Rettighetshaver
export const ALIS_OWNER_ROLES_CODE_F2 = 'F2'; // Rettighetshaver
export const ALIS_OWNER_ROLES_CODE_BASE_A = 'A'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_BASE_G = 'G'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_BASE_F = 'F'; // ektefellepensjon

export const ALIS_OWNER_ROLES_CODE_BASE_C = 'C'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_BASE_H = 'H'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_BASE_E = 'E'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_BASE_J = 'J'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_C1 = 'C1'; // ektefellepensjon
export const ALIS_OWNER_ROLES_CODE_H1 = 'H1'; // livsarvingspensjon
export const ALIS_OWNER_ROLES_CODE_E1 = 'E1'; // barnepensjon
export const ALIS_OWNER_ROLES_CODE_J1 = 'J1'; // samboerpensjon

export const ALIS_OWNER_ROLES_CODE_SPESIELL_BETALER_41 = '41';
export const ALIS_KONTOFORING = 'Kontoføring';
export const ALIS_INVOICE_TYPE_NAME = 'Varsling';

export const PRODUCT_NAMES_MAPPED_TO_FMS: { [key: string]: string } = {
  'Barneforsikring Viderefør': 'insurance.productName.childInsuranceContinued',
};

export const CORPORATE_INNSKUDDSFRITAK_COVERAGE_CODE = 'ISFT0067';

export const POLICY_NUMBER_ID = ':policyNumber';
export const PILLAR_ID = ':pillar';

export enum InsuranceScope {
  PRIVATE = 'private',
  CORPORATE = 'corporate',
}

export enum OrganizationPillarTypes {
  HEALTH = 'HEALTH',
  LIFE = 'LIFE',
  RISK_INSURANCE = 'RISK_INSURANCE',
}

export enum CanChange {
  BEFORE_EFFECT = 'beforeEffect',
  MANUAL = 'manual',
  NORMAL = 'normal',
  RENEWAL = 'renewal',
  NOT_ALLOW = 'notAllow',
  IS_COINSURED = 'isCoinsured',
}
